export default __webpack_public_path__ + "static/media/TECHNOLOGY.4d9a8491.jpg";